export default __webpack_public_path__ + "static/media/007-island.e5fee10c.png";